export default __webpack_public_path__ + "static/media/Icon feather-search (1).7c4fc1d6.svg";